export default import.meta.ROLLUP_FILE_URL_9H3vYAJkr1s5D74C0Wd1zg